/**
 * Created by karora on 17/02/18.
 */

export class HubIssue {
  issue_id: number;
  created: string;
  hubid: number;
  title: string;
  status: number;
  source: number;
  last_action: string;
  action_due: string;
  description: string;
  priority: number;
  user_profile_id: string;
  user_profile_type: number;
  status_text: string;
  source_text: string;
  priority_text: string;
  created_by: string;
  hub_name: string;
  hub_zone: string;
  hub_postcode: string;
  issue_tag_id: number;
  issue_action_id: number;
  customer_followup: boolean;

}
